module.exports = __webpack_public_path__ + "static/img/8.0235766.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/zh/8.png
// module id = sC44
// module chunks = 0